import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const GQL = (props: Props) =>
  gql(`
  query session {
    session {
      activeNotifications
    }
  }
`);

export interface SessionRenders {
  data: Session | null;
  loading: boolean;
  refetch: () => void;
}

interface Props {
  pollInterval?: number;
  children: (renders: SessionRenders) => React.ReactNode;
}

const SessionProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={GQL(props)} pollInterval={props.pollInterval}>
    {({ data, loading, refetch }) => {
      return props.children({
        data: data && data.session,
        loading,
        refetch
      });
    }}
  </AuthorizedQuery>
);

export default SessionProvider;



// WEBPACK FOOTER //
// ./src/providers/SessionProvider.tsx